"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BlockStylesMenu;

var _element = require("@wordpress/element");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _i18n = require("@wordpress/i18n");

var _components = require("@wordpress/components");

var _data = require("@wordpress/data");

var _blocks = require("@wordpress/blocks");

var _blockStyles = _interopRequireDefault(require("../block-styles"));

var _previewBlockPopover = _interopRequireDefault(require("./preview-block-popover"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BlockStylesMenu(_ref) {
  var _ref$hoveredBlock = _ref.hoveredBlock,
      name = _ref$hoveredBlock.name,
      clientId = _ref$hoveredBlock.clientId,
      onSwitch = _ref.onSwitch;

  var _useState = (0, _element.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      hoveredClassName = _useState2[0],
      setHoveredClassName = _useState2[1];

  var blockType = (0, _data.useSelect)(function (select) {
    return select('core/blocks').getBlockType(name);
  }, [name]);
  return (0, _element.createElement)(_components.MenuGroup, {
    label: (0, _i18n.__)('Styles'),
    className: "block-editor-block-switcher__styles__menugroup"
  }, hoveredClassName && (0, _element.createElement)(_previewBlockPopover.default, {
    blocks: blockType.example ? (0, _blocks.getBlockFromExample)(blockType.name, {
      attributes: _objectSpread(_objectSpread({}, blockType.example.attributes), {}, {
        className: hoveredClassName
      }),
      innerBlocks: blockType.example.innerBlocks
    }) : (0, _blocks.cloneBlock)(blockType, {
      className: hoveredClassName
    })
  }), (0, _element.createElement)(_blockStyles.default, {
    clientId: clientId,
    onSwitch: onSwitch,
    onHoverClassName: setHoveredClassName,
    itemRole: "menuitem"
  }));
}
//# sourceMappingURL=block-styles-menu.js.map